import type { Step, StepsCarouselProps } from '@/components/stepsCarousel';
import { StepsCarousel } from '@/components/stepsCarousel';
import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Stack } from '@montugroup/design-system';
import { useTheme } from '@mui/material';
import stepImage1 from '../../../assets/images/stepImage1.jpg';
import stepImage2 from '../../../assets/images/stepImage2.jpg';
import stepImage3 from '../../../assets/images/stepImage3.jpg';

const STEPS: Step[] = [
  {
    stepNumber: 1,
    stepText: 'Upload your script',
    stepImage: stepImage1,
  },
  {
    stepNumber: 2,
    stepText: 'We match you with a trusted pharmacy partner',
    stepImage: stepImage2,
  },
  {
    stepNumber: 3,
    stepText: 'Delivered to your door',
    stepImage: stepImage3,
  },
];

const STEPS_CAROUSEL_PROPS: StepsCarouselProps = {
  titleMobile: 'Your escript to your doorstep',
  titleDesktop: (
    <>
      Your eScript to <br />
      your doorstep
    </>
  ),
  subtitle: 'What to expect from your order:',
  steps: STEPS,
};

export function StepsSection() {
  const theme = useTheme();
  return (
    <Stack sx={{ backgroundColor: outOfBandThemeColors.uMeds.merino100 }}>
      <Box
        width="100%"
        maxWidth={{ xs: theme.spacing(142), md: theme.spacing(360) }}
        margin="0 auto"
        paddingTop={{ xs: 8, md: 34 }}
        paddingBottom={{ xs: 34 }}
        paddingLeft={{ xs: 6, lg: 34 }}
        paddingRight={{ xs: 6, lg: 34 }}
      >
        <StepsCarousel {...STEPS_CAROUSEL_PROPS} />
      </Box>
    </Stack>
  );
}
